import { render, staticRenderFns } from "./DefaultPicture.vue?vue&type=template&id=01f1cbf1&scoped=true&"
import script from "./DefaultPicture.vue?vue&type=script&lang=js&"
export * from "./DefaultPicture.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPicture.vue?vue&type=style&index=0&id=01f1cbf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1cbf1",
  null
  
)

export default component.exports